import { Box } from "monday-ui-react-core";
import type { ReactElement } from "react";

type Props = {
  children: ReactElement | ReactElement[];
};

export function AppTabContent({ children }: Props) {
  return <Box paddingX={Box.paddingXs.XXL}>{children}</Box>;
}
